import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'utils/dayjs';

import MessageBubble from 'components/global/chat/MessageBubble';
import DateWithLine from 'components/global/chat/DateWithLine';

function Messages({ messages, timezone }) {
  const prevLengthRef = useRef(messages.length);

  useEffect(() => {
    if (prevLengthRef.current !== messages.length) {
      const msgDiv = document.getElementById('sidebar-message-list');
      msgDiv.scrollTop = msgDiv.scrollHeight;
    }
    prevLengthRef.current = messages.length;
  }, [messages.length]);

  return (
    <div id="sidebar-message-list" className="sidebar-message-list">
      {messages &&
        messages.map((singleMessage, index, originalArr) => {
          const key = singleMessage.id || singleMessage.timestamp || index;

          // Show a date separator above the first message of each day
          const firstOfDay =
            index === 0 ||
            (originalArr[Number(index) - 1] &&
              !dayjs
                .tz(singleMessage.timestamp, timezone)
                .isSame(
                  dayjs.tz(
                    originalArr[Number(index) - 1].timestamp,
                    timezone,
                  ),
                  'day',
                ));

          const bubble = (
            <MessageBubble
              variant="videoSidebar"
              fromMe={singleMessage.me === true}
              body={singleMessage.body}
              timestamp={dayjs(singleMessage.timestamp)
                .tz(timezone)
                .format('LT')}
              key={`bubble-${key}`}
            />
          );

          if (firstOfDay) {
            return (
              <div key={`date-${key}`}>
                <DateWithLine>
                  {dayjs(singleMessage.timestamp)
                    .tz(timezone)
                    .format('dddd MMMM DD, YYYY')}
                </DateWithLine>
                {bubble}
              </div>
            );
          }
          return bubble;
        })}
    </div>
  );
}

Messages.propTypes = {
  messages: PropTypes.array.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default Messages;
